import { getAddModuleType } from './enums';
const providers = [];
const typedProviderValueMap = new Map();
const typedProviderMap = new Map();
export function addProvider(provider, priority = 0) {
    if (providers.some((p) => p.provider === provider)) {
        return;
    }
    let i;
    for (i = 0; i < providers.length; i++) {
        if (providers[i].priority <= priority) {
            break;
        }
    }
    providers.splice(i, 0, {
        priority,
        provider,
    });
}
const nullProvider = (_query, _data, options) => options?.defaultValue;
function insertPriority(type, list, provider, options) {
    const providerValue = { type, ...options, provider };
    if (!list.find((it) => it.provider === provider)) {
        let i;
        const { priority = 0 } = options;
        for (i = 0; i < list.length; i++) {
            if (list[i].priority <= priority) {
                break;
            }
        }
        list.splice(i, 0, providerValue);
    }
    let currentProvider = nullProvider;
    for (let i = list.length - 1; i >= 0; i--) {
        const p = list[i].provider;
        if (p) {
            currentProvider = p.bind(null, currentProvider);
        }
    }
    return currentProvider;
}
export function addTypedProvider(type, provider, options = { priority: 0, isDefault: true }) {
    if (!provider) {
        throw new Error(`addTypedProvider: cannot register undefined provider for type "${type}"`);
    }
    let list = typedProviderValueMap.get(type);
    if (!list) {
        list = new Array();
        typedProviderValueMap.set(type, list);
    }
    if (list.find((it) => it.provider === provider)) {
        return;
    }
    const newProvider = insertPriority(type, list, provider, options);
    if (!newProvider) {
        throw new Error(`newProvider is empty for ${type}`);
    }
    typedProviderMap.set(type, newProvider);
}
export function addAddProvider(type, provider, options = { priority: 0, isDefault: true }) {
    addTypedProvider(getAddModuleType(type), provider, options);
}
export function metadataModuleProvider(type, query, options) {
    const typedProvider = typedProviderMap.get(type);
    if (!typedProvider) {
        return;
    }
    return typedProvider(query, null, options);
}
export function removeProvider(provider) {
    for (let i = 0; i < providers.length; i++) {
        if (providers[i].provider === provider) {
            providers.splice(i, 1);
            break;
        }
    }
}
const TYPED_PROVIDER_BRIDGE_PRIORITY = -1000;
export function removeAllProviders() {
    while (providers.length > 0) {
        providers.pop();
    }
    typedProviderValueMap.clear();
    typedProviderMap.clear();
}
export function getMetaData(type, query, options) {
    if (query === undefined) {
        return;
    }
    for (let i = 0; i < providers.length; i++) {
        const result = providers[i].provider(type, query, options);
        if (result !== undefined) {
            return result;
        }
    }
}
export function getTyped(type, query, options) {
    return getMetaData(type, query, options);
}
export function addMetaData(type, query, options) {
    return getMetaData(getAddModuleType(type), query, options);
}
export function addTyped(type, query, options) {
    const result = addMetaData(type, query, options);
    return result;
}
export const clearQuery = (type, query) => {
    const typesToClear = [type, getAddModuleType(type)];
    for (const currentType of typesToClear) {
        const typedProviders = typedProviderValueMap.get(currentType);
        if (!typedProviders) {
            continue;
        }
        for (const providerInfo of typedProviders) {
            providerInfo?.clearQuery?.(query);
        }
    }
};
export const clear = (type) => {
    const typesToClear = Array.from(new Set([type, getAddModuleType(type)]));
    for (const currentType of typesToClear) {
        const typedProviders = typedProviderValueMap.get(currentType);
        if (!typedProviders) {
            continue;
        }
        for (const providerInfo of typedProviders) {
            providerInfo?.clear?.();
        }
    }
};
export const get = (type, ...queries) => queries.length === 1
    ? getMetaData(type, queries[0])
    : queries
        .map((query) => query && getMetaData(type, query))
        .find((it) => it !== undefined);
export function getNormalized(imageId, types, metaDataProvider = getMetaData) {
    const result = {};
    for (const t of types) {
        try {
            const data = metaDataProvider(t, imageId);
            if (data) {
                const capitalizedData = {};
                for (const key in data) {
                    if (key in data) {
                        const capitalizedKey = toUpperCamelTag(key);
                        capitalizedData[capitalizedKey] = data[key];
                    }
                }
                Object.assign(result, capitalizedData);
            }
        }
        catch (error) {
            console.error(`Error retrieving ${t} data:`, error);
        }
    }
    return result;
}
export const toUpperCamelTag = (tag) => {
    if (tag.startsWith('sop')) {
        return `SOP${tag.substring(3)}`;
    }
    if (tag.startsWith('voi')) {
        return `VOI${tag.substring(3)}`;
    }
    if (tag.endsWith('Id')) {
        tag = `${tag.substring(0, tag.length - 2)}ID`;
    }
    return tag.charAt(0).toUpperCase() + tag.slice(1);
};
export const toLowerCamelTag = (tag) => {
    if (tag.startsWith('SOP')) {
        return `sop${tag.substring(3)}`;
    }
    if (tag.startsWith('VOI')) {
        return `voi${tag.substring(3)}`;
    }
    if (tag.endsWith('ID') && !tag.endsWith('UID')) {
        tag = `${tag.substring(0, tag.length - 2)}Id`;
    }
    return tag.charAt(0).toLowerCase() + tag.slice(1);
};
